import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import DialogBox from "../Common/DialogBox";
import LinearProgressBar from "../Common/LinearProgressBar";
import VideoPlayer from "../Common/VideoPlayer";
import { useStyles } from "./HelpStyle";

export interface ICheckingForFaultBox {
  displayNextSlide: () => void;
}

const CheckingForFaultsComponent = (props: ICheckingForFaultBox) => {
  const classes = useStyles();

  return (
    <Box>
      <Box
        className={classes.positionComponent}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <VideoPlayer
          videoURL={"asset/video/ScanningProgressVideo.mp4"}
          displayNextSlide={() => {}}
          styles={{
            position: "absolute",
            left: "27%",
            top: "8rem",
            marginTop: "0rem",
            height: "55%",
            width: "70%",
          }}
        />
        <DialogBox
          childProps={
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                height: "inherit",
                width: "inherit",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#fff", fontWeight: 600 }}
              >
                Checking for faults...
              </Typography>
              <LinearProgressBar
                message={""}
                statusComplete={props.displayNextSlide}
                timeInterval={200}
                typoSize={2}
              />
            </div>
          }
          type={3}
        />
      </Box>
    </Box>
  );
};

export default CheckingForFaultsComponent;
